var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCreatepost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 13.875H16.125V7.125C16.125 6.82663 16.0065 6.54048 15.7955 6.32951C15.5845 6.11853 15.2984 6 15 6C14.7016 6 14.4155 6.11853 14.2045 6.32951C13.9935 6.54048 13.875 6.82663 13.875 7.125V13.875H7.125C6.82663 13.875 6.54048 13.9935 6.32951 14.2045C6.11853 14.4155 6 14.7016 6 15C6 15.2984 6.11853 15.5845 6.32951 15.7955C6.54048 16.0065 6.82663 16.125 7.125 16.125H13.875V22.875C13.875 23.1734 13.9935 23.4595 14.2045 23.6705C14.4155 23.8815 14.7016 24 15 24C15.2984 24 15.5845 23.8815 15.7955 23.6705C16.0065 23.4595 16.125 23.1734 16.125 22.875V16.125H22.875C23.1734 16.125 23.4595 16.0065 23.6705 15.7955C23.8815 15.5845 24 15.2984 24 15C24 14.7016 23.8815 14.4155 23.6705 14.2045C23.4595 13.9935 23.1734 13.875 22.875 13.875Z",
    fill: "#121111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreatepost);
export default __webpack_public_path__ + "static/media/icon_createpost.e3817260c4f4a75abf7ae4713cd23fc3.svg";
export { ForwardRef as ReactComponent };